import { ISystemParameterService } from "../../service/systemparameter/SystemParameterService";
import { ISystemParameter } from "../../model/systemparameter/SystemParameter";

export default class UpdateSystemParameterInteractor {
  private systemParameterService: ISystemParameterService;

  constructor(systemParameterService) {
    this.systemParameterService = systemParameterService;
  }

  async execute(systemParameter: ISystemParameter) {
    return this.systemParameterService.updateSystemParameter(systemParameter);
  }
}
